(() => {
  const states = new WeakMap();
  function mount(root) {
    const cards = [...root.querySelectorAll('.jdgm-media-card:not([data-clone-type])')];
    if (!cards.length) return;
    let state = states.get(root);
    if (!state) {
      const de = document.documentElement.lang.startsWith('de');
      const nav = document.createElement('nav');
      nav.className = 'cs-review-pages';
      nav.setAttribute('aria-label', de ? 'Bewertungsseiten' : 'Reviewpagina’s');
      const prev = document.createElement('button'), next = document.createElement('button'), label = document.createElement('span');
      prev.type = next.type = 'button';
      prev.textContent = de ? 'Vorherige Seite' : 'Vorige pagina';
      next.textContent = de ? 'Nächste Seite' : 'Volgende pagina';
      label.setAttribute('aria-live', 'polite');
      nav.append(prev, label, next);
      root.querySelector('.jdgm-cards-carousel').append(nav);
      state = { page: 0, cards, nav, prev, next, label, de };
      states.set(root, state);
      const change = direction => {
        state.page += direction;
        render(state);
        root.scrollIntoView({behavior: 'auto', block: 'start'});
      };
      prev.addEventListener('click', () => change(-1));
      next.addEventListener('click', () => change(1));
    }
    state.cards = cards;
    for (const card of cards) {
      const text = card.querySelector('.jdgm-text');
      if (!text || text.querySelector('.cs-review-copy')) continue;
      const copy = document.createElement('div');
      copy.className = 'cs-review-copy';
      while (text.firstChild) copy.append(text.firstChild);
      const button = document.createElement('button');
      button.className = 'cs-review-more';
      button.type = 'button';
      button.setAttribute('aria-expanded', 'false');
      button.textContent = state.de ? 'Mehr lesen' : 'Meer lezen';
      text.append(copy, button);
      button.addEventListener('click', event => {
        event.stopPropagation();
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        copy.classList.toggle('is-expanded', expanded);
        button.textContent = expanded ? (state.de ? 'Weniger lesen' : 'Minder lezen') : (state.de ? 'Mehr lesen' : 'Meer lezen');
      });
    }
    render(state);
  }
  function render(state) {
    const pages = Math.ceil(state.cards.length / 5);
    state.page = Math.max(0, Math.min(state.page, pages - 1));
    state.cards.forEach((card, i) => {
      const hidden = Math.floor(i / 5) !== state.page;
      card.classList.toggle('cs-review-page-hidden', hidden);
      if (hidden) card.querySelectorAll('video').forEach(video => video.pause());
    });
    state.nav.hidden = pages < 2;
    state.prev.disabled = state.page === 0;
    state.next.disabled = state.page === pages - 1;
    const label = `${state.page + 1} / ${pages}`;
    if (state.label.textContent !== label) state.label.textContent = label;
    requestAnimationFrame(() => state.cards.forEach(card => {
      if (card.classList.contains('cs-review-page-hidden')) return;
      const copy = card.querySelector('.cs-review-copy');
      const button = card.querySelector('.cs-review-more');
      if (copy && button) button.hidden = !copy.classList.contains('is-expanded') && copy.scrollHeight <= copy.clientHeight + 1;
    }));
  }
  let scheduled = false;
  function scan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll('.cs-product-reviews').forEach(mount);
    });
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  window.addEventListener('resize', scan);
  scan();
})();
